import { RemovableRef, useLocalStorage } from '@vueuse/core';

const history: RemovableRef<string[]> = useLocalStorage('STORAGE_KEY_SEARCH_HISTORY', []);
export const useSearchHistory = () => {
  /** 获取搜索记录 */
  function getHistory(): RemovableRef<string[]> {
    return history;
  }
  /** 保存搜索记录 */
  function setHistory(keyword: string) {
    const tmpArr = history.value;
    // 判断keyword是否已经在数组内
    const findIdx = tmpArr.findIndex((item: string) => item === keyword);
    if (findIdx >= 0) {
      // 先删除
      tmpArr.splice(findIdx, 1);
    }
    // 在头部插入
    tmpArr.unshift(keyword);
    // 最多5个记录
    history.value = tmpArr.slice(0, 5);
  }
  /** 清空搜索记录 */
  function clearHistory() {
    history.value = [];
  }

  return {
    getHistory,
    setHistory,
    clearHistory,
  };
};
